import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.FranchiseeSupplierSettingsView.';

  public static readonly applicationTermsOfUse = `${Id.prefix}applicationTermsOfUse`;
  public static readonly quotes = `${Id.prefix}quotes`;
  public static readonly supplierValidityPeriod = `${Id.prefix}supplierValidityPeriod`;
  public static readonly supplierLeadPeriod = `${Id.prefix}supplierLeadPeriod`;
  public static readonly purchaseOrderTermsAndConditions = `${Id.prefix}purchaseOrderTermsAndConditions`;
  public static readonly willCallLocations = `${Id.prefix}willCallLocations`;
  public static readonly willCallLocationsList = `${Id.prefix}willCallLocationsList`;
  public static readonly suppliersConfiguration = `${Id.prefix}suppliersConfiguration`;
}

export class LangFranchiseeSupplierSettingsView {
  private constructor() {}

  public static applicationTermsOfUse(): string {
    return interpolate(Id.applicationTermsOfUse);
  }
  public static quotes(): string {
    return interpolate(Id.quotes);
  }
  public static supplierValidityPeriod(params: { validityPeriod: number }): string {
    return interpolate(Id.supplierValidityPeriod, params);
  }
  public static supplierLeadPeriod(params: { leadPeriod: number }): string {
    return interpolate(Id.supplierLeadPeriod, params);
  }
  public static purchaseOrderTermsAndConditions(): string {
    return interpolate(Id.purchaseOrderTermsAndConditions);
  }
  public static willCallLocations(): string {
    return interpolate(Id.willCallLocations);
  }
  public static willCallLocationsList(params: { locations: string[] | undefined }): string {
    // Join locations as markdown list
    return params.locations?.map(loc => `- ${loc}`).join('\n') ?? '';
  }
  public static suppliersConfiguration(): string {
    return interpolate(Id.suppliersConfiguration);
  }
}

export class FranchiseeSupplierSettingsViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.applicationTermsOfUse, 'Application Terms of Use', 'Section header for application terms of use');
    register.add(Id.quotes, 'Quotes', 'Section header for quotes');
    register.add(
      Id.supplierValidityPeriod,
      'Validity period is **{{validityPeriod}}** day(s)',
      'Supplier validity period message'
    );
    register.add(Id.supplierLeadPeriod, 'Lead period is **{{leadPeriod}}** week(s)', 'Supplier lead period message');
    register.add(
      Id.purchaseOrderTermsAndConditions,
      "{{glossary 'purchase-order:plural'}} Terms & Conditions",
      'Section header for purchase order terms and conditions (plural)'
    );
    register.add(Id.willCallLocations, 'Will Call Locations', 'Section header for will call locations');
    register.add(
      Id.suppliersConfiguration,
      "{{glossary 'supplier:plural'}} Configuration",
      'Caption for suppliers configuration'
    );
  }
}
